// Onboarding 30 Hari (P2) — read-only status of the 8-email sequence. Data from
// GET /v1/bo/onboarding/status (see backoffice.routes.js ->
// models.onboarding.getStatus). Unlike the Retention Engine, this one actually
// SENDS real emails via bot_onboarding.js (SMTP already exists in this codebase) —
// there is no draft/review step here, so treat "sent"/"appreciated" as final.
let churnOnboardingStatusSection = {
  name: "Onboarding 30 Hari",
  slug: "churnOnboardingStatus",
  visible: true,
  singularName: "churnOnboardingStatus",
  crud: true,
  endpoint: "/v1/bo/onboarding/status",
  updateLabel: "churnOnboardingStatus",
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  noNeedSearch: true,
  noNeedRefresh: false,
  add: false,
  update: false,
  edit: false,
  exportToCsv: true,
  fields: [
    {
      label: "Nama",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.name ? row.name : "-"),
    },
    {
      label: "Email",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.email ? row.email : "-"),
    },
    {
      label: "Hari",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.scheduled_day ? row.scheduled_day : "-"),
    },
    {
      label: "Aksi Target",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.action_target ? row.action_target : "-"),
    },
    {
      label: "Selesai?",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.action_completed ? "Ya" : "Belum"),
    },
    {
      label: "Status",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.status ? row.status : "-"),
    },
    {
      label: "Terkirim",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.sent_at ? row.sent_at : "-"),
    },
  ],
};

export default [churnOnboardingStatusSection];
